
<div class="keno-grid-container" style="position: relative">
  <particle-virtual-grid [sourceKey]="fieldDefinition.configKey"
                         [invalidateSubject]="invalidateSubject"
                         (valueChanged)="onGridCellValueChange($event)"
  >
  </particle-virtual-grid>
</div>
